// One definition for server and client in citadel-shared/fileManagement.js
import { archiveFileReasons } from 'citadel-shared/fileManagement.js'

/** CATEGORY STATUS SPECIFIC CONSTS */
const categoryKey = {
  RAW: { label: 'Raw', separateFiles: true, loading: false },
  CONVERTING: { label: 'Converting', separateFiles: true, loading: true },
  CONVERTED: { label: 'Converted', separateFiles: true, loading: false },
  DETERMINING_DUPLICATES: { label: 'Determining Duplicates', separateFiles: true, loading: true },
  DUPLICATES_READY: { label: 'Duplicates Ready', separateFiles: true, loading: false },
  COMBINING_FILES: { label: 'Combining Files', separateFiles: true, loading: true },
  COMBINED: { label: 'Combined', separateFiles: false, loading: false },
  SUGGESTING_REDACTIONS: { label: 'Suggesting Redactions', separateFiles: false, loading: true },
  REDACTIONS_NOTED: { label: 'Redactions Noted', separateFiles: false, loading: false },
  SAVING_REDACTIONS: { label: 'Saving Redactions', separateFiles: false, loading: true },
  FINALIZING_REDACTIONS: { label: 'Finalizing Redactions', separateFiles: false, loading: true },
  REDACTIONS_FINALIZED: { label: 'Redactions Finalized', separateFiles: false, loading: false },
  ADDED_TO_RESPONSE: { label: 'Added to Response', separateFiles: false, loading: false }
}

const categoryStatuses = Object.keys(categoryKey)
const loadingStatuses = categoryStatuses.filter(s => categoryKey[s].loading)
const separateFileCategoryStatuses = categoryStatuses.filter(s => categoryKey[s].separateFiles)
const combinedFileCategoryStatuses = categoryStatuses.filter(s => !categoryKey[s].separateFiles)
const separateCategoryStatusesAllowedEditing = separateFileCategoryStatuses.filter(s => !categoryKey[s].loading)
const separateCategoryStatusesLoadingWillAllowEditing = separateFileCategoryStatuses.filter(s => categoryKey[s].loading && s !== 'COMBINING_FILES')

/** CATEGORY FILE SPECIFIC CONSTS */
const separateFileStatuses = ['RAW', 'CONVERTED']
const redactionFileTypeMap = {
  COMBINED: 'Original',
  REDACTIONS_NOTED: 'Redactions Noted',
  REDACTIONS_APPLIED: 'Redactions Finalized',
  REDACTION_REASONS: 'Redactions Summary'
}
const redactionFileTypes = Object.keys(redactionFileTypeMap)

/** CATEGORY WORKFLOW SPECIFIC CONSTS */
const workflowToCategoryStatusMap = {
  CONVERT: 'CONVERTING',
  FIND_DUPLICATES: 'DETERMINING_DUPLICATES',
  COMBINE_PDF: 'COMBINING_FILES',
  SUGGEST_REDACTIONS: 'SUGGESTING_REDACTIONS',
  APPLY_REDACTIONS: 'FINALIZING_REDACTIONS',
  EDIT_REDACTIONS: 'SAVING_REDACTIONS'
}

export {
  categoryKey,
  categoryStatuses,
  loadingStatuses,
  separateFileCategoryStatuses,
  combinedFileCategoryStatuses,
  separateCategoryStatusesAllowedEditing,
  separateCategoryStatusesLoadingWillAllowEditing,
  archiveFileReasons,
  separateFileStatuses,
  redactionFileTypeMap,
  redactionFileTypes,
  workflowToCategoryStatusMap
}
